import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SplashScreen from '@/components/common/SplashScreen';

// Codes d'erreur bruts envoyés par le back (voir welya-api) : on les mappe vers une clé i18n
// existante plutôt que de les afficher tels quels à l'utilisateur.
const BACKEND_ERROR_CODE_TRANSLATIONS: Record<string, string> = {
  'HTTP.ERROR.403.REPLAY.INDISPONIBLE': 'webinars:publicSignin.replayUnavailable',
  'HTTP.ERROR.404.WEBINAR.NOT.FOUND': 'webinars:publicSignin.webinarNotFound',
  'HTTP.ERROR.404.SESSION.INVITE.NOT.FOUND': 'webinars:publicSignin.sessionInviteNotFound',
};

export default function WebinarErrorPage() {
  const { t } = useTranslation(['common', 'webinars']);
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message');

  const translationKey = message ? BACKEND_ERROR_CODE_TRANSLATIONS[message] : undefined;
  const label = translationKey ? t(translationKey) : t('common:errors.generic');

  return <SplashScreen label={label} fullscreen />;
}
